<template>
    <div>
        <table class="lstTable">
            <tr>
                <th rowspan="2" width="60%">
                    {{$t("lang.fee.description")}}
                </th>
                <th colspan="2" width="40%">
                    {{$t("lang.fee.amount")}}
                </th>
            </tr>
            <tr>
                <th width="20%">
                    {{$t("lang.fee.official")}}
                </th>
                <th width="20%">
                    {{$t("lang.fee.attorney")}}
                </th>
            </tr>
            <tr v-for="(item,index) in payment.lstFee">
                <td class="text-xs-left">
                    {{item.feeName}}
                </td>
                <td align="right">
                    <input type="number" class="tableInput" v-model="item.official" @change="calculatePayment"/>
                </td>
                <td align="right">
                    <input type="number" class="tableInput" v-model="item.attorney"  @change="calculatePayment"/>
                </td>
            </tr>
            <tr>
                <td align="right">{{$t('lang.fee.subtotal')}}</td>
                <td>
                    <input type="number" class="tableInput" v-model="payment.subtotalOfficial" disabled  @change="calculatePayment"/>
                </td>
                <td align="right">
                    <input type="number" class="tableInput" v-model="payment.subtotalAttorney" disabled  @change="calculatePayment"/>

                </td>
            </tr>
            <tr>
                <td align="right">{{$t('lang.fee.discount')}}</td>
                <td>
                </td>
                <td align="right">
                    <input type="number" class="tableInput" v-model="payment.discount" @change="calculatePayment"/>
                </td>
            </tr>
            <tr>
                <td align="right">{{$t('lang.fee.tax')}}</td>
                <td></td>
                <td align="right">
                    <input type="number" class="tableInput" v-model="payment.tax"  @change="calculatePayment"/>
                </td>
            </tr>
            <tr>
                <td align="right">{{$t('lang.fee.bankCharge')}}</td>
                <td>
                </td>
                <td align="right">
                    <input type="number" class="tableInput" v-model="payment.bankCharge"  @change="calculatePayment"/>
                </td>
            </tr>
            <tr style="font-weight: bold">
                <td align="right">{{$t('lang.fee.total')}}</td>
                <td colspan="2" align="right">
                    <input type="number" class="tableInput" disabled v-model="payment.total"/>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";

    export default {
        name: "file-fee",
        components: {},
        props: {
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            showList: true,
            sortField: "",
            orderBy: "asc",
            headers: [
                {
                    text: "lang.common.no",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "5%"
                },
                {
                    text: "lang.procedure.feeName",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "feeName",
                    width: "20%"
                },
                {
                    text: "lang.procedure.unit",
                    align: "right",
                    sortable: false,
                    search: false,
                    value: "unit",
                    width: "15%"
                },
                {
                    text: "lang.procedure.price",
                    align: "right",
                    sortable: false,
                    search: false,
                    value: "fee",
                    width: "10%"
                },
                {
                    text: "lang.files.numberOfObject",
                    align: "right",
                    sortable: false,
                    search: false,
                    value: "numberOfObject",
                    width: "10%"
                },
                {
                    text: "lang.files.total",
                    align: "right",
                    sortable: false,
                    search: false,
                    value: "total",
                    width: "10%"
                }
            ],
            lstTask: [],
            items: [],
            payment: {},
            search: "",
            err: {
                fullName: [],
                phone: [],
                email: []
            },
            editingItem: null,
            editorData: "",
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
            },
            fileId: null,
            task: null,
        }),

        created() {
        },

        methods: {
            calculatePayment() {
                this.payment.subtotalOfficial = 0;
                this.payment.subtotalAttorney = 0;

                for (let i = 0; i < this.payment.lstFee.length; i++) {
                    if (!isNaN(this.payment.lstFee[i].official)) {
                        this.payment.subtotalOfficial += parseInt(this.payment.lstFee[i].official);
                    }
                    if (!isNaN(this.payment.lstFee[i].attorney)) {
                        this.payment.subtotalAttorney += parseInt(this.payment.lstFee[i].attorney);
                    }
                }

                this.payment.total = 0;
                let arr = [this.payment.subtotalOfficial, this.payment.subtotalAttorney, this.payment.tax, this.payment.discount, this.payment.bankCharge];
                for (let i = 0; i < arr.length; i++) {
                    if (isNaN(arr[i])) {
                        continue;
                    }
                    this.payment.total += parseInt(arr[i]);
                }
            },

            getFee(fileId, task) {
                this.fileId = fileId;
                this.task = task;
                axios.post(process.env.VUE_APP_API_URL + "/files/payment/list?fileId=" + this.fileId + "&task=" + encodeURI(this.task)).then(
                    data => {
                        this.payment = data;
                    }
                )
            },

            onSave() {
                for (let i = 0; i < this.items.length; i++) {
                    if (this.items[i].numberOfObject == null || this.items[i].numberOfObject < 0) {
                        message.error("number Of Object is not allow null");
                        return;
                    }
                    this.items[i].total = this.items[i].numberOfObject * this.items[i].fee;

                }
                axios.post(process.env.VUE_APP_API_URL + "/files/payment/save?fileId=" + this.fileId + "&task=" + encodeURI(this.task), this.payment).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.update_success"));
                        } else {
                            message.error(data.description);
                        }
                    }
                )
            },

        }
    };
</script>